var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9325 16.96L13.3992 12.69C13.3236 12.0852 13.0297 11.5288 12.5727 11.1255C12.1157 10.7222 11.527 10.4998 10.9175 10.5H9.08086C8.47163 10.5002 7.88343 10.7228 7.42676 11.1261C6.9701 11.5293 6.67641 12.0855 6.60086 12.69L6.0667 16.96C6.03738 17.1946 6.05831 17.4327 6.12809 17.6586C6.19788 17.8845 6.31492 18.093 6.47145 18.2701C6.62798 18.4473 6.82041 18.5892 7.03597 18.6863C7.25153 18.7834 7.48528 18.8335 7.7217 18.8333H12.2784C12.5147 18.8334 12.7484 18.7832 12.9638 18.686C13.1793 18.5889 13.3716 18.447 13.5281 18.2698C13.6845 18.0927 13.8015 17.8843 13.8712 17.6584C13.9409 17.4326 13.9618 17.1945 13.9325 16.96V16.96Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.1665C11.3807 7.1665 12.5 6.04722 12.5 4.6665C12.5 3.28579 11.3807 2.1665 10 2.1665C8.61929 2.1665 7.5 3.28579 7.5 4.6665C7.5 6.04722 8.61929 7.1665 10 7.1665Z",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 9.66634C4.25383 9.66634 5.00002 8.92015 5.00002 7.99967C5.00002 7.0792 4.25383 6.33301 3.33335 6.33301C2.41288 6.33301 1.66669 7.0792 1.66669 7.99967C1.66669 8.92015 2.41288 9.66634 3.33335 9.66634Z",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.66634C17.5871 9.66634 18.3333 8.92015 18.3333 7.99967C18.3333 7.0792 17.5871 6.33301 16.6667 6.33301C15.7462 6.33301 15 7.0792 15 7.99967C15 8.92015 15.7462 9.66634 16.6667 9.66634Z",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.1665H16.9217C17.3162 12.1665 17.698 12.3064 17.999 12.5613C18.3001 12.8163 18.5009 13.1698 18.5658 13.559L18.8433 15.2257C18.8832 15.4645 18.8705 15.7091 18.8062 15.9424C18.7419 16.1758 18.6275 16.3924 18.4711 16.5771C18.3146 16.7619 18.1197 16.9103 17.9001 17.012C17.6804 17.1138 17.4413 17.1665 17.1992 17.1665H14.1667M3.33334 12.1665H3.07834C2.68381 12.1665 2.30206 12.3064 2.00099 12.5613C1.69993 12.8163 1.49908 13.1698 1.43418 13.559L1.15668 15.2257C1.11685 15.4645 1.12953 15.7091 1.19382 15.9424C1.25811 16.1758 1.37247 16.3924 1.52895 16.5771C1.68543 16.7619 1.88027 16.9103 2.09992 17.012C2.31957 17.1138 2.55876 17.1665 2.80084 17.1665H5.83334L3.33334 12.1665Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeam);
export default __webpack_public_path__ + "static/media/icon__team.82918f02b507bd39a62bf4941a5b354f.svg";
export { ForwardRef as ReactComponent };